import React from 'react'
import i18n from "i18next";
import {Select2} from "select2-react-component";


interface SelectProps {
    changeValue: (data: any) => void
    value: any
    options: { value: string; label: string; disabled?: boolean }[]
    multiple?: boolean
    defaultValue?: {
        label?: string
        isDefault: boolean
        disabled?: boolean
        value?: any
    },
    error: boolean
    disabled?: boolean;
}

const SelectCustom2 = ({
                           changeValue,
                           value,
                           options,
                           multiple,
                           defaultValue = {label: '', isDefault: true, disabled: true},
                           error,
                           disabled,
                           ...rest
                       }: SelectProps) => {
    const {t} = i18n;

    const optionsData = [
        ...(defaultValue.isDefault
            ? [
                {
                    value: -1,
                    label: defaultValue.label || t('form.action.select') || '',
                    disabled: !!defaultValue.disabled,
                    classes: defaultValue.disabled ? 'hidden' : '',
                },
            ]
            : []),
        ...options,
    ]


    const onChangeAction = (val: any) => {
        multiple ?
            changeValue(val)
            :
            changeValue(val != '-1' ? val : undefined)
    }
    return (
        <div className={`select-container ${error ? 'error' : ''}`}>
            <Select2
                multiple={multiple}
                //customSearchEnabled={true}
                disabled={disabled}
                data={optionsData}
                value={value !== undefined && value !== null ? value : -1}
                update={onChangeAction}
                {...rest}
            ></Select2>
        </div>
    )
}

export default SelectCustom2
